<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">

                    <div class="col-12 mb-4">

                        <v-card>
                         <v-card-title>
                              Utilisateurs
                           </v-card-title>
                                            

                            <v-tabs
                                    v-model="tab"
                                    background-color="transparent"
                                    color="basil"
                                    grow
                            >
                                <v-tab
                                        v-for="item in items"
                                        :key="item"
                                >
                                    {{ item }}
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item
                                        key="Administrateurs"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >

                                        <Useradmin />
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item
                                        key="Clients"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >
                                        <Userclient />
                                    </v-card>
                                </v-tab-item>
                                
                                 <v-tab-item
                                        key="Pharmaciens"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >
                                        <Userpharmaciens />
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>


                    </div>
                </div>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import Useradmin from "./Useradmin";
    import Userclient from "./Userclient";
    import Userpharmaciens from "./Userpharmaciens";

    export default {
        name: "UserAll",

        components: {Useradmin,Userclient,Userpharmaciens},
        data() {
            return {
                tab: null,
                items: [
                    'Administrateurs', 'Clients','Pharmaciens'
                ],
                errors: undefined,
                
            }
        }
        ,
        computed: {
           
        }
        ,
        mounted() {
            
        }
        ,
        watch: {
           
        }
        ,
        methods: {
            initialize() {

            }
            
        },
        created() {
            
        }

    }
</script>

<style scoped>

</style>